// extracted by mini-css-extract-plugin
export default {"tabBar":"tab-bar_tabBar__ZACrz","tab":"tab-bar_tab__UrFjo","tab__active":"tab-bar_tab__active__HCuai"};